/**
 * Licensed Materials - Property of IBM IBM Cognos Products: BI Cloud (C)
 *
 * Copyright IBM Corp. 2014, 2017
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./CollapsibleItem',
	'./ToggleMenuBar',
	'../../nls/StringResources',
	'underscore'
], function(CollapsibleItem, ToggleMenuBar, resources, _) {

	var CollapsibleToggleMenuBar = null;

	/**
	 * Represents a drop down menu that can be added to an app bar
	 */
	CollapsibleToggleMenuBar = ToggleMenuBar.extend([CollapsibleItem], {

		/**
		 * Creates a new item
		 *
		 * @param spec -
		 *            The item spec
		 * @param root -
		 *            A reference to the root menu item, where items go if the app bar is collapsed horizontally
		 */
		init: function(spec, root) {
			_.extend(this, spec);
			CollapsibleToggleMenuBar.inherited('init', this, arguments);
			this.rootMenu = root;
			this.bCollapsedRenderDone = false;
		},

		/**
		 * Toggle handler of button
		 * Synchronizes selected item in buttons and menu items.
		 */
		toggleHandler: function(name) {
			this.updateSelectedItem(name);
		},

		updateSelectedItem: function(name) {
			//uncheck current item
			if (this.sCheckedItemName) {
				//un-tick current item in regular menu and hamburger menu
				this.updateMenuItemTick(this.itemMap[this.sCheckedItemName], false);
				this.updateMenuItemTick(this.collapsedItemMap[this.sCheckedItemName], false);
			}

			//update checked item name
			this.sCheckedItemName = name;

			var item = this.itemMap[this.sCheckedItemName];

			//update tick mark on menu item
			this.updateMenuItemTick(item, true);
			if (this.$menuLabel.length > 0){
				this.$menuLabel.text(item.children('a').attr('aria-label'));
			}
			var spec = this.itemSpecMap[name];
			if (spec.icon){
				// Replace existing classes
				this.$iconImage.attr('class', spec.icon);
			}

			//tick on new item in regular menu and hamburger menu
			this.updateMenuItemTick(this.collapsedItemMap[this.sCheckedItemName], true);
			this.updateMenuItemTick(item, true);

			this._updateToggleAriaLabel();
		},

		/**
		 * Toggle handler of menu item in collapsed mode
		 * Synchronizes selected item in buttons and menu items.
		 */
		updateSelectedItemInHamburgerMenu: function(name) {
			CollapsibleToggleMenuBar.inherited('_performAction', this, [this._getItemId(name)]);
		},

		/**
		 * Update aria-label with current selection
		 */
		_updateToggleAriaLabel: function() {
			if (this.sCheckedItemName) {
				var spec = this.itemSpecMap[this.sCheckedItemName];
				this.$toggle.attr('aria-label', resources.get('menuSelectionState_a11y', { item: this.label, selectedItem: spec.label }));
			}

		},
		/**
		 * Draws the items and menu items in rootMenu
		 */
		render: function() {
			//render regular buttons
			this.$el.addClass('hidden-xs');
			CollapsibleToggleMenuBar.inherited('render', this, arguments);

			//render collapsed version. i.e, in hamburger menu
			this.renderCollapsed();

			this._updateToggleAriaLabel();

			return this;
		},

		remove: function() {
			_.each(this.collapsedItemMap, (item) => {
				if (item.remove) {
					item.remove();
				}
			});

			CollapsibleToggleMenuBar.inherited('remove', this, arguments);
		}
	});

	return CollapsibleToggleMenuBar;
});
